import { SelectLanguage, RTL_LANGUAGES } from "@app/constants";
import { useTranslation } from "react-i18next";

export function Footer({ className = "" }) {
  const { i18n } = useTranslation();

  const currentLang = i18n.language.split("-")[0] as SelectLanguage;
  const isRTL = RTL_LANGUAGES.includes(currentLang);

  return (
    <footer className={`page-footer ${className}`}>
      <div className="container">
        <div className="row flex-centered fs-14 txt-black-1">
          {isRTL ? ".Komatsu Ltd ©" : "© Komatsu Ltd."}
        </div>
      </div>
    </footer>
  );
}
